import { render, staticRenderFns } from "./DataObjectsTable.vue?vue&type=template&id=f56d1604&"
import script from "./DataObjectsTable.vue?vue&type=script&lang=js&"
export * from "./DataObjectsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports